import ProfilePage, { ProfilePageProps } from './ProfilePage';

export type { ProfilePageProps };
export default ProfilePage;
